/**
 * Client-side mirror of `server/api/auth/constants.js`. Both files MUST
 * stay in sync: they describe the contract between the BFF auth
 * endpoints and the redux auth slices.
 */

export const OTP_TYPE = Object.freeze({
  SIGNUP: 'signup',
  EMAIL: 'email',
  EMAIL_CHANGE: 'email_change',
  RECOVERY: 'recovery',
});

export const AUTH_STATUS = Object.freeze({
  VERIFIED: 'verified',
  CONFIRMATION_REQUIRED: 'confirmation_required',
  CHANGE_PENDING: 'change_pending',
  LOGGED_OUT: 'logged_out',
  RESENT: 'resent',
  UPDATED: 'updated',
});

export const AUTH_ERROR_CODE = Object.freeze({
  EMAIL_CHANGE_WRONG_BROWSER: 'email_change_wrong_browser',
});
